import ParagraphSkeleton from './ParagraphSkeleton';

const AuthorProfileSkeleton = () => {
  return (
    <div role='status' className='space-y-8 animate-pulse mx-auto'>
      <div className='mb-8'>
        {/* Hero Image */}
        <div className='justify-center w-full h-72 max-h-[260px] md:h-[300px] md:max-h-[300px] bg-gray-200 relative animate-pulse'></div>

        <div className='container px-4 mx-auto'>
          {/* Author Image, Name, Timezone etc. */}
          <div className='flex flex-col md:flex-row items-center pt-8 pb-14 md:pb-8 mx-auto border-b '>
            <div className='bg-gray-200 animate-pulse rounded-full w-16 h-16' />

            <div className='md:ml-4 flex flex-col items-center md:items-start'>
              <div className='bg-gray-200 animate-pulse rounded-md h-6 w-[200px] mt-4 md:mt-0' />
              <div className='bg-gray-200 animate-pulse rounded-md h-4 w-[240px] mt-2 md:mt-2' />
              <div className='bg-gray-200 animate-pulse rounded-md h-4 w-[240px] mt-2 md:mt-2' />
            </div>
          </div>

          {/* About Section / Bio */}
          <div className='py-8'>
            <div className='bg-gray-200 animate-pulse rounded-md h-7 w-[100px] mb-8' />

            <div className='flex flex-col gap-1'>
              <ParagraphSkeleton />
              <ParagraphSkeleton />
              <ParagraphSkeleton />
            </div>
          </div>
        </div>
      </div>
      <span className='sr-only'>Loading...</span>
    </div>
  );
};

export default AuthorProfileSkeleton;
